// extracted by mini-css-extract-plugin
module.exports = {"banner":"index-module__banner___2fEt3"};